import React from 'react';
import { QUIZ_MATCH } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { QuizMatchRoot } from './components/QuizMatchRoot';
import { QuizMatchMobileRoot } from './components/QuizMatchMobileRoot';
import {
  LeftMatchItem,
  QuizMatchProvider,
  RightMatchItem
} from './QuizMatchStore';
import { isMobile } from 'react-device-detect';

interface Props {
  leftItems: LeftMatchItem[];
  rightItems: RightMatchItem[];
}

export type QuizMatchDefinition = ItemDefinition<typeof QUIZ_MATCH, Props>;

export class QuizMatch extends Item<typeof QUIZ_MATCH, Props> {
  protected render({ leftItems, rightItems, id }: RenderProps<Props>) {
    return (
      <QuizMatchProvider leftItems={leftItems} rightItems={rightItems}>
        {isMobile ? <QuizMatchMobileRoot id={id} /> : <QuizMatchRoot id={id} />}
      </QuizMatchProvider>
    );
  }
}

registry[QUIZ_MATCH] = QuizMatch;
